import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ReactComponent as PadlockOutlinedIcon} from 'resources/icons/padlockOutlineIcon.svg';
import {
    BarText,
    BarButton,
    EligibilityBarTemplate,
} from './EligibilityBarTemplate';


export default function GuestBar() {
    const { t } = useTranslation();
    const history = useHistory();
    return (
        <EligibilityBarTemplate color="primary">
            <SvgIcon component={PadlockOutlinedIcon} style={{ fontSize: "2rem" }} viewBox="0 0 88 88" />
            <BarText>{t('eligibilityBar.guestText')}</BarText>
            <BarButton onClick={() => history.push('/signup')}>{t('eligibilityBar.guestButtonText')}</BarButton>
        </EligibilityBarTemplate>
    );
}
